import React from 'react';

const Resume = ({ data, ui }) => {
  if (data) {
    var skillMessage = data.skill_message;
    var education = data.education.map(function (education) {
      return <div key={education.school}><h3>{education.school}</h3>
        <p className="info">{education.degree} <span>&bull;</span><em className="date">{education.graduated}</em></p>
        <p>{education.description}</p></div>
    })
    var work = data.work.map(function (work) {
      return <div key={work.company}><h3>{work.url ? <a href={work.url} target="_blank" rel="noopener noreferrer">{work.company}</a> : work.company}</h3>
        <p className="info">{work.title}<span>&bull;</span> <em className="date">{work.years}</em></p>
        <p>{work.description}</p>
        <p><b>{ui.techStack}:</b> {work.stack}</p>
        <br></br>
      </div>
    })
    var skills = data.skills.map(function (skills) {
      var className = 'bar-expand ' + skills.name.toLowerCase();
      return <li key={skills.name}><span style={{ width: skills.level }} className={className}></span><em>{skills.name}</em></li>
    })
  }

  return (
    <section id="resume">

      <div className="row education">
        <div className="three columns header-col">
          <h1><span>{ui.education}</span></h1>
        </div>

        <div className="nine columns main-col">
          <div className="row item">
            <div className="twelve columns">
              {education}
            </div>
          </div>
        </div>
      </div>


      <div className="row work">

        <div className="three columns header-col">
          <h1><span>{ui.work}</span></h1>
        </div>

        <div className="nine columns main-col">
          {work}
        </div>
      </div>



      <div className="row skill">

        <div className="three columns header-col">
          <h1><span>{ui.skills}</span></h1>
        </div>

        <div className="nine columns main-col">
          <p>{skillMessage}</p>
          <div className="bars">
            <ul className="skills">
              {skills}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Resume;
